import { render, staticRenderFns } from "./othercheckout.vue?vue&type=template&id=6c31d83c"
import script from "./othercheckout.vue?vue&type=script&lang=js"
export * from "./othercheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports